import React, { useEffect, useReducer, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import styled from 'styled-components'
import Paypal from './Paypal'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import Cookies from 'universal-cookie'
import WhyDoWeChargeAFee from '../WhyDoWeChargeAFee'
import TestimonialsPanel from '../TestimonialsPanel'
import moment from 'moment'
import {
  Title,
  Subtitle,
  ActionButtons,
  Input,
  LoadingButton,
} from '../Utils/CustomClasses'
//import { scrollIntoView } from '../Hooks/ScrollView'
const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 767px) {
    padding: 0 25px 25px 25px;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const CenterSmallMargin = styled(Center)`
  margin-top: 30px;
`

const PaymentButton = styled(ActionButtons)`
  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }
`

const PaymentLoadingButton = styled(LoadingButton)`
  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }
`

const BackButton = styled(ActionButtons)`
  /*
  background-color: #fff;
  border: 1px solid #000;
  */
  color: #fff;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 10px 0 0;
  }

  @media screen and (min-width: 769px) {
    max-width: 150px;
  }
`

const PriceChoiceBox = styled.div`
  background-color: transparent;
  border-radius: 10px;
  /*
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  */
  padding: 20px 30px;
  margin: 0;
  width: 100%;
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 60px;
  align-items: top;
  justify-content: left;
  margin-top: 10px;

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBoxHeaderBadgeContainer = styled.div`
  flex-basis: 50%;
  position: relative;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  text-transform: capitalize;
`

const PriceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
  min-width: 230px;

  @media (min-width: 1200px) {
    margin-left: 9vw;
  }
`

const PriceBoxHeader = styled.div`
  background-color: #000a84;
  padding: 6px;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 18px auto 34px;
  width: 170px;
  position: relative;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 10px 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`
const PriceSubtitleNoStrikePrice = styled(PriceSubtitle)`
  margin: -9px 16px 0 0;
`

const PriceSubtitleStrike = styled(Subtitle)`
  color: #ff0000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  font-size: 20px;
  text-decoration: line-through;
  width: 100%;
`

const PriceSubtitleNoStrike = styled(PriceSubtitleStrike)`
  text-decoration: none;
`

const PriceSubtitleNoStrikeSub = styled(PriceSubtitleNoStrike)`
  color: #6a6a6a;
  font-weight: 400;
  font-size: 13px;
  margin: 9px 0 0 0;
  width: 100%;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -30px 4px 0 0;
`

const CurrencySubtitleNoStrike = styled(CurrencySubtitle)`
  margin: -46px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: #6a6a6a;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 0 0 2px;
  text-transform: uppercase;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    margin: 0 auto 20px;
    width: 100%;
    max-width: 140px;
  }
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  max-width: 250px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  span {
    color: #ff0000;
    font-weight: 700;
    text-decoration: line-through;
  }

  @media (max-width: 799px) {
    font-size: 17px !important;
    width: 210px;
  }
`

const InfoBox = styled.div`
  flex-basis: 50%;
`

const PayBox = styled.div`
  @media (min-width: 1200px) {
    margin-left: 9vw;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  margin: 24px 20px 30px 0;

  span {
    text-transform: capitalize;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
    margin: 0 20px 50px 0;
  }
`

const FlexRowDiscount = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
`

const RowButtons = styled.div`
  margin-top: 10px;

  @media (max-width: 799px) {
    margin-top: 20px;
  }
`

const DiscountSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 24px 20px 8px 0;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const DiscountInput = styled(Input)`
  margin: 0 0 10px 0;
  max-width: 417px;
`

const DiscountButton = styled(ActionButtons)`
  background-color: #0171d5;
  padding: 8px 30px;
`

const DiscountLoadingButton = styled(LoadingButton)`
  background-color: #0171d5;
  padding: 13px 30px;
`

const DiscountMessageSubtitle = styled(Subtitle)`
  background-color: #ffff00;
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 5px 20px 8px 0;
  padding: 5px 12px;
  border-radius: 6px;

  span {
    color: #ff0000;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
    margin: 5px 0 8px 0;
  }
`

const DiscountErrorMessageSubtitle = styled(DiscountMessageSubtitle)`
  color: #ff0000;
`

const FlexRowButtonsBottom = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 60px;
  font-size: 16px;

  @media (max-width: 799px) {
    flex-direction: column-reverse;
    margin-top: 30px;
  }
`

const TestimonialsWrapper = styled.div`
  margin: 0;
`

const PriceBoxList = styled.ul`
  margin: 30px 1vw 40px;

  width: 100%;
  max-width: 420px;

  @media screen and (max-width: 799px) {
    margin: 0 auto 40px;
  }
`

const PblI = styled.li`
  color: #ffffff;
  margin: 0 0 24px 20px;
  position: relative;
  font-size: 18px;

  &::before {
    content: url('images/onboarding/tick-green.svg');
    font-size: 20px;
    position: absolute;
    left: -30px;
    width: 24px;
  }

  @media screen and (min-width: 1100px) {
    font-size: 17px;
  }
`

const ChoosePaymentOptionOnboardingMonthly = ({
  dCode,
  data,
  actionRef,
  isCopied,
  onComplete,
}) => {
  const [originalMembershipFee, setOriginalMembershipFee] = useState('4.99')
  const [membershipFee, setMembershipFee] = useState('4.99')
  const [preDiscountMembershipFee, setPreDiscountMembershipFee] =
    useState('4.99')
  const [subscriptionType, setSubscriptionType] = useState('monthly')
  const [currencySign, setCurrencySign] = useState('')
  const [loading, setLoading] = useState(false)
  const [checkout, setCheckout] = useState(false)
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [displayChoice, setDisplayChoice] = useState(0)
  const [discounted, setDiscounted] = useState(false)
  const [discountCode, setDiscountCode] = useState(null)
  const [discountAmount, setDiscountAmount] = useState(null)
  const [discountType, setDiscountType] = useState(null)
  const [discountMessage, setDiscountMessage] = useState('')
  const [discountErrorMessage, setDiscountErrorMessage] = useState('')
  const [discountLoading, setDiscountLoading] = useState(false)
  const [voucherCode, setVoucherCode] = useState(false)
  const [subscriptionDisplay, setSubscriptionDisplay] = useState([])
  const [subscriptionDisplayLong, setSubscriptionDisplayLong] = useState([])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'choose-membership-fee-page-loaded',
      data.auth.user.id + ' - choose membership fee - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          if (pageValue === 'profile-pay') {
            const subsDisplayShort = [
              pageText[56],
              pageText[25],
              pageText[28],
              pageText[33],
            ]
            const subsDisplayLong = [
              pageText[56],
              pageText[44],
              pageText[45],
              pageText[46],
            ]

            console.log('subsDisplayShort: ' + JSON.stringify(subsDisplayShort))
            console.log('subsDisplayLong: ' + JSON.stringify(subsDisplayLong))

            setSubscriptionDisplay(subsDisplayShort)
            setSubscriptionDisplayLong(subsDisplayLong)
          }

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const userData = cookies.get('uD')

    console.log('==============================')
    console.log('userData: ' + JSON.stringify(userData))

    if (userData) {
      setOriginalMembershipFee(userData.originalMembershipFee)
      setMembershipFee(userData.membershipFee)
      setSubscriptionType(userData.subscriptionType)
      if (userData.subscriptionType === 'monthly') {
        setDisplayChoice(0)
      } else {
        setDisplayChoice(3)
      }

      if (userData.preDiscountMembershipFee !== 0) {
        setDiscounted(true)
        setPreDiscountMembershipFee(userData.preDiscountMembershipFee)
        setDiscountType(userData.discountType)
        setDiscountAmount(userData.discount)
        setDiscountCode(userData.voucherCode)
      }
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    getCurrency()

    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  useEffect(() => {
    if (isCopied === true) {
      setDiscountCode(dCode)
      setDiscountMessage('<span>' + pageText[55] + '</span>')
    }
  }, [isCopied, dCode, pageText])

  const handleUpdateCode = (e) => {
    setDiscountLoading(false)
    setDiscountMessage('')
    setDiscountErrorMessage('')
    setDiscountCode(e)
  }

  const handleApplyDiscount = () => {
    console.log('handleApplyDiscount...')
    setDiscountErrorMessage('')

    if (discountCode) {
      console.log('discountCode' + discountCode)
      setDiscountLoading(true)
      axios
        .get(`api/discount-voucher/${discountCode}`)
        .then((response) => {
          console.log('response' + JSON.stringify(response))

          if (Object.keys(response.data).length > 0) {
            if (
              moment() >= moment(response.data.startDate) &&
              moment() <= moment(response.data.endDate).add(1, 'days')
            ) {
              setDiscounted(true)
              setDiscountAmount(response.data.discountAmount)
              setDiscountType(response.data.discountUnit)

              let discountedFeeCalculated = 0.0

              console.log('membershipFee' + JSON.stringify(membershipFee))

              if (response.data.discountUnit === 'PER') {
                discountedFeeCalculated = (
                  parseFloat(originalMembershipFee).toFixed(2) -
                  (
                    parseFloat(originalMembershipFee).toFixed(2) *
                      (response.data.discountAmount / 100) +
                    0.0001
                  ).toFixed(2)
                ).toFixed(2)

                setMembershipFee(discountedFeeCalculated)
                setPreDiscountMembershipFee(originalMembershipFee)

                setDiscountMessage(
                  pageText[48] +
                    ' <strong><span>' +
                    discountCode +
                    '</span></strong> ' +
                    pageText[49] +
                    ' <strong><span>' +
                    response.data.discountAmount +
                    '%</span></strong>.'
                )

                cookies.set('dtd', true, { path: '/' })
                cookies.set('dtdoamt', discountedFeeCalculated, { path: '/' })
              } else if (response.data.discountUnit === 'MTH') {
                if (subscriptionType === 'annual') {
                  setDiscountErrorMessage(
                    'You are trying to add a monthly offer code for an annual subscription. Please either go back to the previous page and choose a monthly subscription or use an annual offer code.'
                  )
                  setDiscounted(false)
                } else {
                  discountedFeeCalculated = originalMembershipFee
                  setMembershipFee(discountedFeeCalculated)

                  setDiscountMessage(
                    'Offer code <span><strong>' +
                      discountCode +
                      '</strong></span> has been added. Your subscription is ' +
                      ' <span><strong>' +
                      'free for the first ' +
                      response.data.discountAmount +
                      ' months' +
                      '</span></strong>. To continue with membership you still need to enter payment details, but rest assured <span><strong>you will not be charged for the first ' +
                      response.data.discountAmount +
                      ' months</span></strong>, and can cancel anytime.'
                  )

                  cookies.set('dtd', true, { path: '/' })
                  cookies.set('dtdoamt', discountedFeeCalculated, { path: '/' })
                }
              }
            } else {
              setDiscountErrorMessage(pageText[50])
              setDiscounted(false)
            }
          } else {
            setDiscountErrorMessage(pageText[50])
            setDiscounted(false)
          }
        })
        .catch((err) => {
          console.log('Error getting discount code: ', err)
          setDiscounted(false)
        })
        .finally(() => {
          setDiscountLoading(false)
        })
    } else {
      setDiscountErrorMessage(pageText[51])
      setDiscounted(false)
      setDiscountLoading(false)
    }
  }

  const handleChooePaypal = () => {
    gaEvents.eventGeneric(
      'button_click',
      'paypal-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Paypal'
    )
    // redirect to Paypal
    setCheckout(true)
  }

  const handleSubmit = () => {
    console.log('submit ' + discountCode)
    gaEvents.eventGeneric(
      'button_click',
      'stripe-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Stripe'
    )
    setLoading(true)

    var preDiscountMembershipFeeVal = preDiscountMembershipFee

    if (discountType === null && subscriptionType === 'annual') {
      preDiscountMembershipFeeVal = 0
    }

    const userData = {
      originalMembershipFee: originalMembershipFee,
      preDiscountMembershipFee: preDiscountMembershipFeeVal,
      membershipFee: membershipFee,
      subscriptionType: subscriptionType,
      discount: discountAmount,
      discountType: discountType,
      voucherCode: discountCode,
    }

    console.log('>> userData : ' + JSON.stringify(userData))

    cookies.set('uD', userData, { path: '/' })

    data.auth.updateUser(userData).then(() => {
      if (discounted) {
        setTimeout(function () {
          onComplete('mp3')
        }, 1000)
      } else {
        console.log('nothing ' + discountCode)
        setTimeout(function () {
          onComplete('mp3')
          setLoading(false)
        }, 1000)
      }
    })
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container" ref={actionRef}>
      <div className="row justify-content-center">
        {checkout ? (
          <div>
            <div>
              <Paypal
                user={data.auth.user}
                actionRef={actionRef}
                subscriptionType={subscriptionType}
                membershipFee={membershipFee}
                discount={discountAmount}
                discountType={discountType}
                discountCode={discountCode}
                currencySign={data.auth.user.currencyValue}
              />
            </div>

            <div className="text-center">
              <BackButton
                type="submit"
                padding="10px 40px"
                margin="15px 0 20px 12px"
                onClick={(e) => {
                  setCheckout(false)
                }}
              >
                {pageText[10]}
              </BackButton>
            </div>
          </div>
        ) : (
          <ContainerBox>
            <OnboardingTitle
              center
              color="#ff9900"
              size="34px"
              sizemd="34px"
              sizesm="34px"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[57]}`,
              }}
            ></OnboardingTitle>

            <OnboardingSubtitle
              center
              color="#fff"
              size="18px"
              margin="30px 0 20px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[71]}`,
              }}
            />

            {/*
            <OnboardingSubtitle
              center
              color="#fff"
              size="20px"
              sizesm="20px"
              weight="700"
              margin="20px 0 10px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[58]}`,
              }}
            />
            */}

            <form
              method="POST"
              action="/"
              name="myForm"
              aria-label="Add Profile"
              onSubmit={(event) => {
                event.preventDefault()
                return false
              }}
              style={{ marginTop: 0 }}
            >
              <input
                type="hidden"
                name="csrf-token"
                value={window.Laravel.csrfToken}
              />

              <PriceChoiceBox>
                <FlexRowPrice>
                  <PriceBoxHeaderBadgeContainer>
                    <PriceBox>
                      <PriceBoxHeader>
                        {' '}
                        <PriceHeaderSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${subscriptionType}`,
                          }}
                        />
                      </PriceBoxHeader>
                      <PriceBoxPrice>
                        <PriceContainer>
                          {discounted ? (
                            discountType !== 'MTH' ? (
                              <>
                                <PriceSubtitleStrike
                                  center
                                  size="50px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${currencySign}${(Math.round(preDiscountMembershipFee * 100) / 100).toFixed(2)}`,
                                  }}
                                />
                                <CurrencySubtitle
                                  center
                                  size="16px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${currencySign}`,
                                  }}
                                />
                                <PriceSubtitleNoStrikePrice
                                  center
                                  size="50px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                  }}
                                />
                              </>
                            ) : discountType === 'MTH' &&
                              subscriptionType === 'annual' ? (
                              <>
                                <CurrencySubtitle
                                  center
                                  size="16px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${currencySign}`,
                                  }}
                                />
                                <PriceSubtitle
                                  center
                                  size="50px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <PriceSubtitleNoStrike
                                  center
                                  size="50px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${discountAmount} MONTHS FREE`,
                                  }}
                                />
                                <PriceSubtitleNoStrikeSub
                                  center
                                  size="13px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `THEN`,
                                  }}
                                />
                                <CurrencySubtitleNoStrike
                                  center
                                  size="16px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${currencySign}`,
                                  }}
                                />
                                <PriceSubtitleNoStrikePrice
                                  center
                                  size="50px"
                                  margin="0"
                                  dangerouslySetInnerHTML={{
                                    __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                  }}
                                />
                              </>
                            )
                          ) : (
                            <>
                              <CurrencySubtitle
                                center
                                size="16px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}`,
                                }}
                              />
                              <PriceSubtitle
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                }}
                              />
                            </>
                          )}

                          <PriceDurationSubtitle
                            center
                            size="13px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `${subscriptionDisplay[displayChoice]}`,
                            }}
                          />
                        </PriceContainer>
                      </PriceBoxPrice>
                      <PriceBoxInfo>
                        {' '}
                        {displayChoice == 0 ? (
                          <img src={'images/onboarding/icon-coffee-solo.svg'} />
                        ) : (
                          <img
                            src={
                              'images/onboarding/icon-annual-connections.svg'
                            }
                          />
                        )}
                        <PriceInfoSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${displayChoice == 0 ? pageText[72] : 'Ideal for the avid traveller, an annual membership offers you more time to build meaningful connections, plan trips, organise meetups and more with fellow Freebird Club members.<br/><b>Get 3 Months Free with Annual Fee</b>'}`,
                          }}
                        />
                      </PriceBoxInfo>
                    </PriceBox>
                  </PriceBoxHeaderBadgeContainer>

                  <InfoBox>
                    <PriceBoxList>
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[63]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[64]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[65]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[66]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[67]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[68]}`,
                        }}
                      />
                      <PblI
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[69]}`,
                        }}
                      />
                    </PriceBoxList>

                    <PriceChoiceSubtitle
                      color="#fff"
                      size="18px"
                      margin="0 0 10px 1%"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[41]}`,
                      }}
                    />
                  </InfoBox>
                </FlexRowPrice>

                <RowButtons>
                  <PayBox>
                    {' '}
                    <DiscountSubtitle
                      color="#fff"
                      size="18px"
                      margin="0 0 6px 0px"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[52]}:`,
                      }}
                    />
                    <FlexRowDiscount>
                      {' '}
                      <DiscountInput
                        id="discountcode"
                        type="text"
                        name="discountcode"
                        value={discountCode}
                        placeholder={pageText[54]}
                        onChange={(e) => handleUpdateCode(e.target.value)}
                      />
                      {discountLoading ? (
                        <DiscountLoadingButton
                          padding="10px 30px"
                          onClick={() => {
                            handleApplyDiscount()
                          }}
                        ></DiscountLoadingButton>
                      ) : (
                        <DiscountButton
                          padding="10px 30px"
                          onClick={() => {
                            handleApplyDiscount()
                          }}
                        >
                          {pageText[53]}
                        </DiscountButton>
                      )}
                    </FlexRowDiscount>
                    {discountMessage && (
                      <DiscountMessageSubtitle
                        size="16px"
                        dangerouslySetInnerHTML={{
                          __html: `${discountMessage}`,
                        }}
                      />
                    )}
                    {discountErrorMessage && (
                      <DiscountErrorMessageSubtitle
                        size="16px"
                        dangerouslySetInnerHTML={{
                          __html: `${discountErrorMessage}`,
                        }}
                      />
                    )}
                    <FlexRowButtonsBottom>
                      {loading ? (
                        <PaymentLoadingButton padding="11px 35px 11px 43px">
                          {pageText[6] + ' ' + pageText[7]}
                        </PaymentLoadingButton>
                      ) : (
                        <PaymentButton
                          padding="10px 30px"
                          onClick={() => {
                            handleSubmit()
                          }}
                        >
                          <img src="/images/icons/card.svg" />{' '}
                          {pageText[6] + ' ' + pageText[7]}
                        </PaymentButton>
                      )}

                      <PaymentButton
                        blackText
                        padding="11px 30px"
                        background="#FCBB32"
                        onClick={() => {
                          handleChooePaypal()
                        }}
                      >
                        {pageText[6] + ' by'}
                        <img src="/images/icons/paypal.svg" />
                      </PaymentButton>
                    </FlexRowButtonsBottom>
                  </PayBox>
                </RowButtons>
              </PriceChoiceBox>

              <CenterSmallMargin>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </CenterSmallMargin>

              {/* Trust & Security / ID */}
              <WhyDoWeChargeAFee
                pageText={pageText}
                pageText2={pageText2}
                color={'transparent'}
                textcolor="#fff"
              />

              {/* Testimonials */}
              <TestimonialsWrapper>
                <TestimonialsPanel
                  color={'transparent'}
                  textcolor={'#ffffff'}
                  showintro={false}
                  numbertoshow={6}
                />
              </TestimonialsWrapper>

              <Center>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app2"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app2"
                />
              </Center>
            </form>
          </ContainerBox>
        )}
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChoosePaymentOptionOnboardingMonthly))
